import React, { FunctionComponent } from "react";
import styles from "./css/DeliveryInfo.module.css";
import ellipse from "../../assets/ellipse.png";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Delivery } from "../../svg_groups/delivery";
import { Return } from "../../svg_groups/return";
import { CustomerCare } from "../../svg_groups/customerCare";

const DeliveryInfo = () => {
  const language = useSelector((state: any) => state.language.value);

  return (
    <div className={styles.frag} style={{ backgroundColor: "#F9F6E9" }}>
      <div className={styles.mainContainer}>
        <div className={styles.flexParent}>
          <div className={styles.paperVersion}>
            <Delivery />
            <span className={styles.paperVersion10}>
              {language == "RO" && <>Livrare</>}
              {language == "EN" && <>Delivery</>}
            </span>
            <span className={styles.paperVersion10}>
              {language == "RO" && <>TBD TBD TBD TBD</>}
              {language == "EN" && <>TBD TBD TBD TBD</>}
            </span>
          </div>
          <div className={styles.paperVersion}>
            <Return />
            <span className={styles.paperVersion10}>
              {language == "RO" && <>Intoarcere</>}
              {language == "EN" && <>Return</>}
            </span>
            <span className={styles.paperVersion10}>
              {language == "RO" && <>TBD TBD TBD TBD</>}
              {language == "EN" && <>TBD TBD TBD TBD</>}
            </span>
          </div>
          <div className={styles.paperVersion}>
            <CustomerCare />
            <span className={styles.paperVersion10}>
              {language == "RO" && <>Asistență Clienți</>}
              {language == "EN" && <>Customer Care</>}
            </span>
            <span className={styles.paperVersion10}>
              {language == "RO" && <>TBD TBD TBD TBD</>}
              {language == "EN" && <>TBD TBD TBD TBD</>}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryInfo;
